import { render, staticRenderFns } from "./ContractBreedStandardForm.vue?vue&type=template&id=5e7706a9&"
import script from "./ContractBreedStandardForm.vue?vue&type=script&lang=js&"
export * from "./ContractBreedStandardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports